// Helper function to get required environment variables
function getRequiredEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Required environment variable ${name} is not set`);
  }
  return value;
}

export const config = {
  apiUrl: getRequiredEnv('REACT_APP_API_URL'),
  googleClientId: getRequiredEnv('REACT_APP_GOOGLE_CLIENT_ID'),
  appleClientId: getRequiredEnv('REACT_APP_APPLE_CLIENT_ID'),
  appleRedirectUri: getRequiredEnv('REACT_APP_APPLE_REDIRECT_URI'),
  awsS3Art: getRequiredEnv('REACT_APP_AWS_S3_ART'),
  awsS3ArtSmall: getRequiredEnv('REACT_APP_AWS_S3_ART_SMALL'),
  awsS3Avatars: getRequiredEnv('REACT_APP_AWS_S3_AVATARS'),
  awsS3LibraryBucket: getRequiredEnv('REACT_APP_AWS_S3_LIBRARY'),
  awsS3WaveformsBucket: getRequiredEnv('REACT_APP_AWS_S3_WAVEFORMS'),
  awsRegion: getRequiredEnv('REACT_APP_AWS_REGION'),
}; 

if (process.env.NODE_ENV === 'production1') {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  //console.error = () => {}; // Consider keeping error logs for production monitoring
}